import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAccount } from "../models/account/IAccount";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useAccount(accountId?: string, componentName = "useAccount") {
  const { get, put, getFile } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const account = useQuery({
    queryKey: ["accounts", accountId],
    queryFn: () => get<DefaultResponseWithData<IAccount>>(`/account/${accountId}`),
    enabled: !!accountId,
  });

  const update = useMutation(
    (account: IAccount) => put(`/account/${accountId}`, account),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["accounts"]);
      },
    }
  );

  return {
    account,
    update,
  };
}
